import { render, staticRenderFns } from "./myChoice.vue?vue&type=template&id=04fe0922&scoped=true"
import script from "./myChoice.vue?vue&type=script&lang=js"
export * from "./myChoice.vue?vue&type=script&lang=js"
import style0 from "./myChoice.vue?vue&type=style&index=0&id=04fe0922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fe0922",
  null
  
)

export default component.exports